import React, { useState, useEffect } from 'react';
import { showTemporaryMessage } from "../components/Message";
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../components/AuthProvider';

import PickUser from '../components/PickUser';
import PickBearer from '../components/PickBearer';

const Bearers = () => {
	const { userType, loginToken, userId } = React.useContext(AuthContext);
	const { t } = useTranslation();

	const [selectedUserId, setSelectedUserId] = useState(0);
	// TODO: Remove?
	// Dummy value that just triggers a refresh of PickUser
	const [refreshTrigger, setRefreshTrigger] = useState(0);

	/**
	 * REGULAR users can only administer bearers relating to
	 * their own User ID, so we choose this ID for them.
	 */
	useEffect(() => {
		if(userType === 'REGULAR') {
			setSelectedUserId(userId);
		}
	}, []);

	const updateUsersState = () => {
		setRefreshTrigger(prev => prev + 1);
	};

	return (
		<div className="flex-grow min-w-full">
			{/* Natasha: Why did this className cause the rest of the components on the page to disappear? */}
			{/*<div {className="min-h-full" > */}
			<div className="">
				{/* Heading */}
				<div className="w-full bg-light-blue shadow mb-10">
					<div className="super-admin w-full bg-light-blue shadow mb-10">
						<div className="max-w-screen-xl mx-auto py-4 px-4 text-center sm:text-start">
							<h1 className="text-4xl font-extrabold text-black">{t("page_bearers")}</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="max-w-screen-xl mx-auto px-4">
				<div className="mx-auto w-full sm:px-12 lg:px-36">
					{/* Dashboard content */}
					<div className="px-4 py-6 sm:px-0">
					<h2 className="text-2xl font-bold mb-6">{t("bearers_page_instructions")}</h2>
						<div>
						{/* Only let ADMIN and SUPERUSER users pick which user to administer */ }
						{ (userType == 'ADMIN' || userType == 'SUPERUSER') &&
						<PickUser
							loginToken={loginToken}
							setSelectedUserId={setSelectedUserId}
							filter={(user) => user.type === 'REGULAR'}
							refreshTrigger={refreshTrigger} /> }
						</div>

						{/* TODO: To be updated if more components are added			  */}
						{/* PickBearer \												  */}
						{/*			   |												  */}
						{/*			   + ListOfBearers									  */}
						{/*			   |												  */}
						{/*			   \ BearerDetails \								  */}
						{/*							   |								  */}
						{/*							   \ ScanTokens \					  */}
						{/*											|					  */}
						{/*											+ ScanTokenNameChange */}
						{/*											|					  */}
						{/*											\ Scans				  */}
						{/* Note that Scans is only shown to admin users */ }
						{ selectedUserId != 0 && <PickBearer
							loginToken={loginToken}
							loggedInUserId={userId}
							loggedInUserType={userType}
							selectedUserId={selectedUserId}
							updateUsersState={updateUsersState} /> }
					</div>
				</div>
			</div>
		</div>
	);
};

export default Bearers;

